import { call, put, takeLatest } from "redux-saga/effects";
import { FetchAddressServiceFailure, FetchAddressServiceInit, FetchAddressServiceSuccess } from "./FetchAddressSlice";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from "../../../constants/AppConstants";
import { getLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { handleError } from "../../SagaError";
import i18next from "i18next";
import { _CALLGETAPI } from "../../../api/apiHandler";

function __GETSHIPPINGADDRESSLIST(){
    const endpoint = _API_ENDPOINT.GET_BILLING_AND_SHIPPING_ADDRESS;
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);

    const payload = {
        params: {
            'userId': UID
        }
    }
    return _CALLGETAPI(endpoint, payload)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}
function* handleShippingAddressList(){
    try {
        const shippingAddressList = yield call(__GETSHIPPINGADDRESSLIST);
        (shippingAddressList.actionStatus.toUpperCase() === SUCCESS)
        ? yield put(FetchAddressServiceSuccess(shippingAddressList))
        : yield* handleError(FetchAddressServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"));
    } catch(error) {
        yield* handleError(FetchAddressServiceFailure, error.message);
    }
}

export default function* watchFetchShippingAddressService() {
 yield takeLatest(FetchAddressServiceInit.type, handleShippingAddressList)      
}